// extracted by mini-css-extract-plugin
module.exports = {"seoHeading":"_3iMOV","seoSubHeading":"_7dMVf"};